import { render } from "./ValidateOtp.vue?vue&type=template&id=2453fc2a&scoped=true"
import script from "./ValidateOtp.vue?vue&type=script&lang=js"
export * from "./ValidateOtp.vue?vue&type=script&lang=js"

import "./ValidateOtp.vue?vue&type=style&index=0&id=2453fc2a&lang=scss&scoped=true"

import exportComponent from "D:\\Build Apps\\Natan\\jlm_manager\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2453fc2a"]])

export default __exports__